import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import StateSave from "./StateSave";


const StateNew = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    let response33 = useInvoke("WebApps", "33", null);

    useEffect(() => {

        //get countries
        if (response33.data.payload != undefined && response33.isPending == false) {
            let data = JSON.parse(response33.data.payload).data;

            let select = document.getElementById("countryID");

            let defaultOption = document.createElement('option');
            defaultOption.text = "Select Country";
            defaultOption.value = "";
            select.options.add(defaultOption);

            data.forEach(country => {
                let option = document.createElement('option');
                option.text = country[1];
                option.value = country[0];
                select.options.add(option);
            });
        }

    }, [response33.isPending]);

    const handleFormSubmit = (e) => {
        
        let stateid = "";

        let valid = true;

        let statename = "";
        if (document.getElementById("state").value != '') {
            statename = document.getElementById("state").value;
        }
        else {
            valid = false;
            toast.error("State Name required");
        }

        let stateabbr = "";
        if (document.getElementById("state").value != '') {
            stateabbr = document.getElementById("abbr").value;
        }
        else {
            valid = false;
            toast.error("State Name required");
        }

        let modifiedbyid = user["id"];
        let deleted = "0";

        let countryid = "";
        if (document.getElementById("countryID").value != "") {
            countryid = document.getElementById("countryID").value;
        }
        else {
            valid = false;
            toast.error("Country required");
        }

        if(valid) {
            StateSave(stateid, statename, stateabbr, modifiedbyid, deleted, countryid);
            toast.success('Success');
            navigate("/State");
        }
    };
    
    document.title = "Customers - New";
    return ( 
        <div className="stateNew">
            {user["email"] != undefined && 
                <>
                    {(response33.isPending == false) &&
                    
                        <div className="container body-content" style={{marginTop: "25px"}}>
                                
                            <h2>New State</h2>

                            <form id="stateForm" noValidate="novalidate" autoComplete="off">  

                                <div className="form-group">
                                    <label htmlFor="countryID">Country</label>
                                    <select className="form-control" id="countryID" name="countryID"></select>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="state">State / Province</label>
                                    <input className="form-control" id="state" name="state" type="text" autoComplete="off" />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="abbr">Abbr</label>
                                    <input className="form-control" id="abbr" name="abbr" type="text" autoComplete="off" />
                                </div>
            
                            </form>
                            <Link to="/State" className="btn btn-default" style={{marginRight: "4px"}}>Cancel</Link>
                            <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>
                        </div>
                    }
                </>
            }
        </div>
     );
}
 
export default StateNew;